import { render, staticRenderFns } from "./WalletSettlementCollectionReceipt.vue?vue&type=template&id=c84fcb90&scoped=true&"
import script from "./WalletSettlementCollectionReceipt.vue?vue&type=script&lang=js&"
export * from "./WalletSettlementCollectionReceipt.vue?vue&type=script&lang=js&"
import style0 from "./WalletSettlementCollectionReceipt.vue?vue&type=style&index=0&id=c84fcb90&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c84fcb90",
  null
  
)

export default component.exports